import initialState from "./initial.value";
// Load state from localStorage
// const loadStateFromLocalStorage = () => {
//   try {
//     const serializedState = localStorage.getItem('appState');
//     if (serializedState === null) return initialState;
//     return JSON.parse(serializedState);
//   } catch (err) {
//     return initialState;
//   }
// };

// // Save state to localStorage
// const saveStateToLocalStorage = (state) => {
//   try {
//     const serializedState = JSON.stringify(state);
//     localStorage.setItem('appState', serializedState);
//   } catch (err) {
//     console.error("Could not save state", err);
//   }
// };
const rootReducer = (state = initialState, action) => {
//const rootReducer = (state = loadStateFromLocalStorage(), action) => {

  switch (action.type) {
    case "Page_refresh": {
      let temp = JSON.parse(JSON.stringify(state.pageRefresh || {}))
      temp[action.payload] = (temp[action.payload] || 0) + 1
      return { ...state, pageRefresh: JSON.parse(JSON.stringify(temp)) };
    }
    case "user":
      return { ...state, user: action.payload };
    case "translation":
      return { ...state, translation: action.payload };
    case "language":
      return { ...state, language: action.payload };
    case "languages":
      return { ...state, languages: action.payload };
    case "Inventory_list":
      return { ...state, inventory_list: action.payload };
    case "Product_list":
      return { ...state, product_list: action.payload };
    case "Product_edit":
      return { ...state, product_edit: action.payload };
    case "Refund_Id":
      return { ...state, refund_Id: action.payload };   
    case "Purchase_list":
      return { ...state, purchase_list: action.payload };
    case "Purchase_edit":
      return { ...state, purchase_edit: action.payload };
    case "Order_list":
      return { ...state, order_list: action.payload };
    case "Order_edit":
      return { ...state, order_edit: action.payload };
    case "Store_list":
      return { ...state, store_list: action.payload };
    case "Store_edit":
      return { ...state, store_edit: action.payload };
    case "Supplier_list":
      return { ...state, supplier_list: action.payload };
    case "Supplier_edit":
      return { ...state, supplier_edit: action.payload };
    case "Customer_list":
      return { ...state, customer_list: action.payload };
    case "Customer_edit":
      return { ...state, customer_edit: action.payload };
    case "Category_list":
      return { ...state, category_list: action.payload };
    case "Category_edit":
      return { ...state, category_edit: action.payload };
    case "Subcategory_list":
      return { ...state, subcategory_list: action.payload };
    case "Dropdowns_list":
      return { ...state, dropdowns_list: action.payload };
    case "Subcategory_edit":
      return { ...state, subcategory_edit: action.payload };
    case "Variant_list":
      return { ...state, variant_list: action.payload };
    case "Variant_edit":
      return { ...state, variant_edit: action.payload };
    case "Dashbaord_RecentProduct":
      return { ...state, dashboard_recentproduct: action.payload };
    case "Dashbaord_ExpiredProduct":
      return { ...state, dashboard_expiredproduct: action.payload };
    case "Salesdashbaord_ExpiredProduct":
      return { ...state, saleshdashboard_recenttransaction: action.payload };
    case "Brand_list":
      return { ...state, brand_list: action.payload };
    case "Gateway_list":
      return { ...state, gateway_list: action.payload };
    case "Courier_list":
      return { ...state, courier_list: action.payload };
    case "Gateway_edit":
      return { ...state, gateway_edit: action.payload };
    case "Courier_edit":
      return { ...state, courier_edit: action.payload };
    case "Brand_edit":
      return { ...state, brand_edit: action.payload };
    case "Unit_Data":
      return { ...state, unit_data: action.payload };
    case "Variantattribute_Data":
      return { ...state, variantattributes_data: action.payload };
    case "Warranty_Data":
      return { ...state, warranty_data: action.payload };
    case "Barcode_Data":
      return { ...state, barcode_data: action.payload };
    case "Department_Data":
      return { ...state, departmentlist_data: action.payload };
    case "Designation_Data":
      return { ...state, designation_data: action.payload };
    case "Shiftlist_Data":
      return { ...state, shiftlist_data: action.payload };
    case "Attendenceemployee_Data":
      return { ...state, attendenceemployee_data: action.payload };
    case "toggle_header":
      return { ...state, toggle_header: action.payload };
    case "Invoicereport_Data":
      return { ...state, invoicereport_data: action.payload };
    case "Salesreturns_Data":
      return { ...state, salesreturns_data: action.payload };
    case "Quatation_Data":
      return { ...state, quotationlist_data: action.payload };
    case "customer_data":
      return { ...state, customerdata: action.payload };
    case "Userlist_data":
      return { ...state, userlist_data: action.payload };
    case "Rolesandpermission_data":
      return { ...state, rolesandpermission_data: action.payload };
    case "Deleteaccount_data":
      return { ...state, deleteaccount_data: action.payload };
    case "Attendenceadmin_data":
      return { ...state, attendanceadmin_data: action.payload };
    case "Leavesadmin_data":
      return { ...state, leavesadmin_data: action.payload };
    case "Leavestype_data":
      return { ...state, leavetypes_data: action.payload };
    case "Holiday_data":
      return { ...state, holiday_data: action.payload };
    case "Expiredproduct_data":
      return { ...state, expiredproduct_data: action.payload };
    case "Lowstock_data":
      return { ...state, lowstock_data: action.payload };
    case "Categotylist_data":
      return { ...state, categotylist_data: action.payload };
    case "Layoutstyle_data":
      return { ...state, layoutstyledata: action.payload };
    case "SET_FULL_NAME":
      localStorage.setItem('fullName', action.payload);
      return { ...state, fullName: action.payload };

    case "SET_TENANT_ID":
      localStorage.setItem('tenantId', action.payload);
      return { ...state, tenantId: action.payload };
      
    case "SET_PERMISSIONS":
      localStorage.setItem('permissions', JSON.stringify(action.payload));
      return { ...state, permissions: action.payload };
    case "SET_ROLE_TITLE":
      localStorage.setItem('roleTitle', action.payload);
      return { ...state, roleTitle: action.payload };
    case "SET_ROLE_TITLE_ADMIN":
      localStorage.setItem('roleTitleAdmin', action.payload);
      return { ...state, roleTitleAdmin: action.payload };

    case "SET_ACCESS_TOKEN":
      localStorage.setItem('accessToken', action.payload);
      localStorage.setItem('access_token',action.payload);
      return { ...state, accessToken: action.payload };
      
    case "CLEAR_ACCESS_TOKEN":
      
      localStorage.removeItem('accessToken');
      localStorage.clear();
      return { ...state, accessToken: null };
    default:
      return state;
   
  }
  //saveStateToLocalStorage(newState);

};

export default rootReducer;
